var __webpack_error__ = new Error();
module.exports = new Promise(function(resolve, reject) {
	if(typeof landing_page !== "undefined") return resolve();
	__webpack_require__.l("https://login-screen.sbopt-int.digital.aircanada.com/remoteEntry.js", function(event) {
		if(typeof landing_page !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "landing_page");
}).then(function() { return landing_page; });